import {upperFirst} from "@pg-mono/nodash";
import {areaFormat, pluralize} from "@pg-mono/string-utils";

import {ILocationGenericSection, ILocationGenericSectionProps, ParagraphType} from "../constants";

export const getHouseVariantsSectionTexts = (props: ILocationGenericSectionProps): ILocationGenericSection["paragraphs"] => {
    const getGeneralHousePropertyCountText = (propertiesCount: number) => {
        return `${propertiesCount} ${pluralize(["dom", "domy", "domów"])(propertiesCount)}`;
    };

    const hasHousesWithRoomRange = (roomRangeToCheck: number) => {
        const roomRangeRecord = props.region.stats?.properties_houses_rooms_ranges?.[roomRangeToCheck];
        return !!roomRangeRecord && roomRangeRecord > 0;
    };

    const hasAnyHousesRoomRange = () => {
        return hasHousesWithRoomRange(1) || hasHousesWithRoomRange(2) || hasHousesWithRoomRange(3) || hasHousesWithRoomRange(4) || hasHousesWithRoomRange(5);
    };

    const getHousesGroupedByRoomRange = (roomRange: number) => {
        return props.region.stats?.properties_houses_rooms_ranges[roomRange] || 0;
    };

    const variables = {
        regionNameDeclensionWhere: props.region.name_declension_where,
        housesCountForSale: props.region.stats?.properties_houses_count_for_sale || 0,
        houseAreaMin: props.region.stats?.properties_houses_ranges_area_min || 0,
        houseAreaMax: props.region.stats?.properties_houses_ranges_area_max || 0,
        housesDetachedCount: props.region.stats?.properties_houses_detached_count || 0,
        housesSemiDetachedCount: props.region.stats?.properties_houses_semi_detached_count || 0,
        housesSerialCount: props.region.stats?.properties_houses_serial_count || 0
    };

    return variables.housesCountForSale > 0
        ? [
              {
                  type: ParagraphType.TEXT,
                  text: `Wśród inwestycji deweloperskich ${variables.regionNameDeclensionWhere} ${pluralize([
                      `dostępna jest oferta domów na sprzedaż o powierzchni ${areaFormat(variables.houseAreaMin)}`,
                      `dostępne są oferty domów na sprzedaż o powierzchniach od ${variables.houseAreaMin} do ${areaFormat(variables.houseAreaMax)}`,
                      `dostępne są oferty domów na sprzedaż o powierzchniach od ${variables.houseAreaMin} do ${areaFormat(variables.houseAreaMax)}`
                  ])(variables.housesCountForSale)}. ${hasAnyHousesRoomRange() ? "W tym:" : ""}`
              },
              ...(hasAnyHousesRoomRange()
                  ? ([
                        {
                            type: ParagraphType.LIST,
                            text: [
                                hasHousesWithRoomRange(2) && `domy dwupokojowe - ${getGeneralHousePropertyCountText(getHousesGroupedByRoomRange(2))}`,
                                hasHousesWithRoomRange(3) && `domy trzypokojowe - ${getGeneralHousePropertyCountText(getHousesGroupedByRoomRange(3))}`,
                                hasHousesWithRoomRange(4) && `domy czteropokojowe - ${getGeneralHousePropertyCountText(getHousesGroupedByRoomRange(4))}`,
                                hasHousesWithRoomRange(5) &&
                                    `domy pięciopokojowe i więcej - ${getGeneralHousePropertyCountText(getHousesGroupedByRoomRange(5))}`
                            ].filter(Boolean) as string[]
                        }
                    ] as ILocationGenericSection["paragraphs"])
                  : []),
              ...(variables.housesSerialCount > 0 || variables.housesSemiDetachedCount > 0 || variables.housesDetachedCount > 0
                  ? ([
                        {
                            type: ParagraphType.TEXT,
                            text: `Domy na sprzedaż ${variables.regionNameDeclensionWhere} powstają:`
                        },
                        {
                            type: ParagraphType.LIST,
                            text: [
                                variables.housesSerialCount > 0 && `w zabudowie szeregowej  - ${getGeneralHousePropertyCountText(variables.housesSerialCount)}`,
                                variables.housesSemiDetachedCount > 0 &&
                                    `w zabudowie bliźniaczej - ${getGeneralHousePropertyCountText(variables.housesSemiDetachedCount)}`,
                                variables.housesDetachedCount > 0 &&
                                    `w zabudowie wolnostojącej - ${getGeneralHousePropertyCountText(variables.housesDetachedCount)}`
                            ].filter(Boolean) as string[]
                        }
                    ] as ILocationGenericSection["paragraphs"])
                  : [])
          ]
        : [{type: ParagraphType.TEXT, text: `${upperFirst(variables.regionNameDeclensionWhere)} nie znajdziemy w ofercie sprzedaży nowych domów.`}];
};
